import { render, staticRenderFns } from "./RtbPartnerDetails.vue?vue&type=template&id=700bd6e5&scoped=true&"
import script from "./RtbPartnerDetails.vue?vue&type=script&lang=js&"
export * from "./RtbPartnerDetails.vue?vue&type=script&lang=js&"
import style0 from "./RtbPartnerDetails.vue?vue&type=style&index=0&id=700bd6e5&prod&lang=scss&"
import style1 from "./RtbPartnerDetails.vue?vue&type=style&index=1&id=700bd6e5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700bd6e5",
  null
  
)

export default component.exports